import { useNavigate } from 'react-router-dom';

import { Button } from '@dmp/components/ui/Button/Button';
import { ROUTE_PATHS } from '@dmp/constant/routePaths';

/** Shared "restricted access" page rendered by every route guard denial branch, mirroring the styling of `pages/NotFound/NotFound.tsx` for a consistent look. */
const RestrictedAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-[20px]">
      <div className="text-[40px] font-bold">403</div>
      <div className="text-[20px]">You don&apos;t have permission to view this page</div>
      <Button variant="primary" onClick={() => navigate(ROUTE_PATHS.LANDING_PAGE)}>
        Go to Landing Page
      </Button>
    </div>
  );
};

export default RestrictedAccess;
